import * as BoardsService from 'common/services/boards.service';
import { getBoardsSucceed } from '../actions';

export function getBoards(params = {}) {
  return async dispatch => {
    try {
      const boards = await BoardsService.getBoards(params);
      dispatch(getBoardsSucceed(boards));
    } catch (e) {
      // Handle failure when an indication is needed
    }
  };
}
